export const BYB_CONTRACT_ADDRESS = "0xfbcb83037d770b28F758530022897362521b6141";

export const TOKEN_MARKET_LINKS = [
  {
    label: "CoinGecko",
    href: "https://www.coingecko.com/en/coins/biorbank",
    description: "Price, volume, and market overview.",
  },
  {
    label: "CoinMarketCap",
    href: "https://coinmarketcap.com/currencies/biorbank/",
    description: "Ranking, market cap, and token profile.",
  },
  {
    label: "DEXTools",
    href: "https://www.dextools.io/app/en/ether/pair-explorer/0x8a8d931bd9ec82f75e2ba67e451eb35e48b216f9?t=1742478631023",
    description: "Pair explorer, swaps, and on-chain analytics.",
  },
  {
    label: "DEX Screener",
    href: "https://dexscreener.com/ethereum/0x8a8d931bd9ec82f75e2ba67e451eb35e48b216f9",
    description: "Live charting and pair tracking.",
  },
];
